import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <AdminLayout>
      <h1 className="font-display text-3xl font-bold text-slate-900">Audit Log</h1>
      <p className="mt-1 text-slate-500">Significant changes to orders, payments, pricing and customer settings.</p>

      <div className="mt-6 rounded-lg border border-[#E5E7EB] bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#E5E7EB] text-left text-xs uppercase tracking-widest text-slate-400">
              <th className="px-4 py-3">When</th>
              <th className="px-4 py-3">Actor</th>
              <th className="px-4 py-3">Action</th>
              <th className="px-4 py-3">Detail</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E5E7EB]">
            {logs.map((l) => (
              <tr key={l.id} className="hover:bg-[#F9FAFB]">
                <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{fmtDateTime(l.created_at)}</td>
                <td className="px-4 py-3 text-slate-700">{l.actor_email}</td>
                <td className="px-4 py-3"><span className="rounded bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">{l.action}</span></td>
                <td className="px-4 py-3 text-slate-600">{l.detail}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-slate-400">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
